export default {
  HOME: '/',
  DETAIL_TX: '/tx/:txHash',
};
